import { AnalyticsEventType } from './analytics-event-type.enum';
var AnalyticsLogger = /** @class */ (function () {
    function AnalyticsLogger() {
    }
    AnalyticsLogger.sessionStart = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.SESSION_START,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logPageView = function (httpPost, apiPath, locale, sourceType, sourceId, itemId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.PAGE_VIEW,
            locale: locale,
            itemId: itemId,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logSearchResultClickMore = function (httpPost, apiPath, locale, sourceType, sourceId, text) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.SEARCH_RESULTS_CLICKED_MORE,
            locale: locale,
            text: text,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logSearchResultIgnored = function (httpPost, apiPath, locale, sourceType, sourceId, text) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.SEARCH_RESULTS_IGNORED,
            locale: locale,
            text: text,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logSearchResultNone = function (httpPost, apiPath, locale, sourceType, sourceId, text) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.SEARCH_RESULTS_NONE,
            locale: locale,
            text: text,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logSearchResultArticleClicked = function (httpPost, apiPath, locale, sourceType, sourceId, text, articleId, position) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.SEARCH_RESULTS_ARTICLE_CLICKED,
            locale: locale,
            text: text,
            itemId: articleId,
            sourceType: sourceType,
            sourceId: sourceId,
            position: position + 1
        });
    };
    AnalyticsLogger.logContactSupportClick = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.CONTACT_SUPPORT,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logVoteItem = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.VOTE,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logUnvoteItem = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.UN_VOTE,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logHelpfulItem = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.HELPFUL,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.logUnhelpfulItem = function (httpPost, apiPath, locale, sourceType, sourceId) {
        httpPost(apiPath + this.analyticsPath, {
            type: AnalyticsEventType.UNHELPFUL,
            locale: locale,
            sourceType: sourceType,
            sourceId: sourceId
        });
    };
    AnalyticsLogger.analyticsPath = '/analytics';
    return AnalyticsLogger;
}());
export { AnalyticsLogger };
//# sourceMappingURL=analytics-logger.js.map